import * as React from 'react';
import AnalystRecommendations from './AnalystRecommendations';
import CeoCompensation from './CeoCompensation';
import Home from './Home';
import Price from './Price';
import PricePerformanceChart from './PricePerformanceChart';
import Profile from './Profile';
import Extended from './Extended';
import EstimatedValuation from './EstimatedValuation';
import EstimatedPaybackTime from './EstimatedPaybackTime';
import InsiderTransactions from './InsiderTransactions';
import NotEnoughData from './NotEnoughData';
import NotEnoughDataYet from './NotEnoughDataYet';
import GrowthRates from './financials/GrowthRates';
import HistoricalFinancials from './financials/HistoricalFinancials';
import HistoricalIncome from './financials/HistoricalIncome';
import HistoricalBalanceSheet from './financials/HistoricalBalanceSheet';
import HistoricalCashflow from './financials/HistoricalCashflow';
import ManagementScore from './financials/ManagementScore';
import MoatScore from './financials/MoatScore';
import TenKFilings from './financials/TenKFilings';
import EightKFilings from './financials/EightKFilings';
import TenQFilings from './financials/TenQFilings';
import ProxyStatements from './financials/ProxyStatements';
import ValueCalculator from './financials/ValueCalculator';
import ValueScore from './financials/ValueScore';
import MovieIcon from '@mui/icons-material/Movie';
import PointOfSaleOutlinedIcon from '@mui/icons-material/PointOfSaleOutlined';
import EngineeringOutlinedIcon from '@mui/icons-material/EngineeringOutlined';
import CastleOutlinedIcon from '@mui/icons-material/CastleOutlined';
import SavingsOutlinedIcon from '@mui/icons-material/SavingsOutlined';
import ChatAssistants from './ChatAssistants';
import EarningsCallTranscriptListDataGrid from './EarningsCallTranscriptListDataGrid';
import {Adsense} from '@ctrl/react-adsense';

function Ticker({data} :any) {

  function isGrowthRateAvailable(growthRate) {
    return (
      (growthRate.one_year === null)
        && (growthRate.three_years === null)
        && (growthRate.five_years === null)
        && (growthRate.seven_years === null)
        && (growthRate.ten_years === null)
        && (growthRate.growth_number === null)
    );
  }

  function hideCalculations() {
    return (
      (isGrowthRateAvailable(data.equity_growth_rates) === true)
        && (isGrowthRateAvailable(data.cash_growth_rates) === true)
        &&  (isGrowthRateAvailable(data.eps_growth_rates) === true)
        &&  (isGrowthRateAvailable(data.revenue_growth_rates) === true)
    );
  }

  if (hideCalculations()) {
    return (
      <div>
        <Home />
        <div className="page-header">
          <h3 className="page-title">{data.company_name}</h3>
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item"><a href="/">Home</a></li>
              <li className="breadcrumb-item active" aria-current="page">{data.ticker}</li>
            </ol>
          </nav>
        </div>
          <div className="row">
            <Price data={data} />
            <Profile data={data} />
            <Extended data={data} />
            <div className="col-12 grid-margin">
              <PricePerformanceChart
                ticker={data.ticker}
                variant="inline"
                fullPageHref={`/ticker/${data.ticker}/price_performance`}
              />
            </div>
            <NotEnoughDataYet data={data} />
            <TenKFilings data={data} />
            <TenQFilings data={data} />
            <EightKFilings data={data} />
            <ProxyStatements data={data} />
          </div>
      </div>
    );
  }
  else if (!hideCalculations()) {
    return (
      <div>
        <Home />
        <div className="page-header">
          <h3 className="page-title">{data.company_name}</h3>
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item"><a href="/">Home</a></li>
              <li className="breadcrumb-item active" aria-current="page">{data.company_name}</li>
            </ol>
          </nav>
        </div>
          <div className="row">
          {console.log(data.estimated_valuation)}

            <div className="col-12 col-sm-6 col-md-3 grid-margin stretch-card">
              <div className={`card`} >
                <div className="card-body">
                  <div className="d-flex justify-content-center">
                    <i className="mdi mdi-clock icon-lg text-primary d-flex align-items-center">
                      <PointOfSaleOutlinedIcon />
                    </i>
                    <div className="d-flex flex-column ml-4">
                      <div className="d-flex flex-column">
                        <p className="mb-0">Value Score</p>
                        <h4 className="font-weight-bold">{data.decode_investing_score}%</h4>
                      </div>
                      <small className="text-muted">{data.decode_investing_score_meaning}</small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-sm-6 col-md-3 grid-margin stretch-card">
              <div className={`card`} >
                <div className="card-body">
                  <div className="d-flex justify-content-center">
                    <i className="mdi mdi-cart-outline icon-lg text-success d-flex align-items-center">
                      <EngineeringOutlinedIcon  />
                    </i>
                    <div className="d-flex flex-column ml-4">
                      <div className="d-flex flex-column">
                        <p className="mb-0">Management Score</p>
                        <h4 className="font-weight-bold">{data.management_score}%</h4>
                      </div>
                      <small className="text-muted">{data.management_score_meaning}</small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-sm-6 col-md-3 grid-margin stretch-card">
              <div className={`card`}>
                <div className="card-body">
                  <div className="d-flex justify-content-center">
                    <i className="mdi mdi-laptop icon-lg text-info d-flex align-items-center">
                      <CastleOutlinedIcon />
                    </i>
                    <div className="d-flex flex-column ml-4">
                      <div className="d-flex flex-column">
                        <p className="mb-0">Moat Score</p>
                        <h4 className="font-weight-bold">{data.moat_score}%</h4>
                      </div>
                      <small className="text-muted">{data.moat_score_meaning}</small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-sm-6 col-md-3 grid-margin stretch-card">
              <div className={`card`}>
                <div className="card-body">
                  <div className="d-flex justify-content-center">
                    <i className="mdi mdi-earth icon-lg text-danger d-flex align-items-center">
                      <SavingsOutlinedIcon />
                    </i>
                    <div className="d-flex flex-column ml-4">
                      <div className="d-flex flex-column">
                        <p className="mb-0">Debt Score</p>
                        <h4 className="font-weight-bold">{data.debt_score}%</h4>
                      </div>
                      <small className="text-muted">{data.debt_score_meaning}</small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Price data={data} />
            <Profile data={data} />
            <Extended data={data} />
            <div className="col-12 grid-margin">
              <PricePerformanceChart
                ticker={data.ticker}
                variant="inline"
                fullPageHref={`/ticker/${data.ticker}/price_performance`}
              />
            </div>
            <EstimatedValuation data={data}/>
            <EstimatedPaybackTime payback_time={data.estimated_valuation.payback_time} />
            <ValueCalculator data={data} />
            <GrowthRates data={data} />
            <ChatAssistants data={data} />
            <HistoricalIncome data={data} />
            <HistoricalBalanceSheet data={data} />
            <HistoricalCashflow data={data} />
            <InsiderTransactions data={data} />
            <div className="col-lg-12 grid-margin stretch-card">
              <div className="card">
                <div className="card-body">
                <h4 className="card-title">{data?.transcript_list.company} Earnings Calls Transcripts</h4>
                  <p className="card-description">
                    Analyze and review {data.ticker}'s Earnings Call Transcripts with our AI assistant. Select a transcript below:
                  </p>
                  <EarningsCallTranscriptListDataGrid transcript_list={data?.transcript_list} />
                </div>
              </div>
            </div>
            <TenKFilings filings={data.filings} />
            <TenQFilings filings={data.filings} />
            <EightKFilings filings={data.filings} />
            <ProxyStatements filings={data.filings} />
          </div>
      </div>
    );
  } else {
    return (
      <div>
        <Home />
        <div className="page-header">
          <h3 className="page-title">{data.company_name}</h3>
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item"><a href="/">Home</a></li>
              <li className="breadcrumb-item active" aria-current="page">{data.ticker}</li>
            </ol>
          </nav>
        </div>
          <div className="row">
            <Price data={data} />
            <Profile data={data} />
            <Extended data={data} />
            <div className="col-12 grid-margin">
              <PricePerformanceChart
                ticker={data.ticker}
                variant="inline"
                fullPageHref={`/ticker/${data.ticker}/price_performance`}
              />
            </div>
            <NotEnoughData data={data} />
          </div>
      </div>
    );
  }
}

export default Ticker;
